import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ReactQuill from 'react-quill';

import * as actions from './actions';
import { EditorContainer, QuillContainer, AlignBox, AlignBoxLeft, AlignBoxRight } from './styles';
import { Button } from 'components/Button/RoundButton';
import { Spinner } from 'components/Spinner/Spinner';
import { useActions } from 'hooks/useActions';

const Editor = {
  modules: {
    toolbar: [
      [{ header: '1' }, { header: '2' }],
      ['bold', 'italic', 'underline'],
      [{ align: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['code-block', 'link', 'clean'],
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
  },
  formats: ['header', 'bold', 'italic', 'underline', 'list', 'bullet', 'link', 'align', 'code-block'],
};

export default function CommentEditor({ onCancel, onPostSuccess, testId, contestId, respondsTo }) {
  const { postComment } = useActions(actions);
  const {
    createCommentStatus: { [respondsTo ? respondsTo : 'root']: commentStatus },
  } = useSelector((state) => state.commentsReducer);

  const [newComment, setNewComment] = useState(
    localStorage.getItem(`fsComment-${contestId || testId}-${respondsTo || 'root'}`)
  );

  useEffect(() => {
    if (commentStatus === 'success') {
      setNewComment('');
      localStorage.removeItem(`fsComment-${contestId || testId}-${respondsTo || 'root'}`);
      if (onPostSuccess) {
        onPostSuccess();
      }
    }
  }, [commentStatus, contestId, onPostSuccess, respondsTo, testId]);

  const onChange = (updatedValue) => {
    setNewComment(updatedValue);
    localStorage.setItem(`fsComment-${contestId || testId}-${respondsTo || 'root'}`, updatedValue);
  };

  return (
    <EditorContainer>
      {commentStatus === 'posting' && <Spinner />}
      {commentStatus !== 'posting' && (
        <>
          <QuillContainer>
            <ReactQuill
              value={newComment}
              onChange={onChange}
              modules={Editor.modules}
              formats={Editor.formats}
              theme="snow"
              preserveWhitespace={true}
            />
          </QuillContainer>
          <AlignBox>
            <AlignBoxLeft />
            <AlignBoxRight>
              {onCancel && (
                <Button small primaryBlue primaryGreenBorder removeMargin type="submit" onClick={() => onCancel()}>
                  Cancel
                </Button>
              )}
              <Button
                small
                primaryBlue
                primaryGreenBorder
                removeMargin
                disabled={!newComment || commentStatus === 'posting'}
                onClick={() => postComment(newComment, testId, contestId, respondsTo)}
              >
                Post Comment
              </Button>
            </AlignBoxRight>
          </AlignBox>
        </>
      )}
    </EditorContainer>
  );
}
